// extracted by mini-css-extract-plugin
export default {"icon":"icon_icon__etm4x","hasBackground":"icon_hasBackground__wIlg2"};